import type { DatapointOptions, CustomDataMap, INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT, } from "owa-analytics-types";
import GreyErrorDatapoint from "../datapoints/GreyErrorDatapoint";
import { logDatapoint } from "./logDatapoint";
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from "owa-analytics-events";
import type { MailboxInfo } from "owa-client-types";

const listeners: Array<(eventName: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined, error?: Error, customData?: CustomDataMap, options?: DatapointOptions) => void> = [];

export function logGreyError(eventName: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined, error?: Error, customData?: CustomDataMap, options?: DatapointOptions): Promise<void> {
    for (const listener of listeners) {
        listener(eventName, mailbox, error, customData, options);
    }
    
    return logDatapoint(new GreyErrorDatapoint(eventName, mailbox, error || new Error("GreyError"), customData, options));
}

export function registerGreyErrorListener(listener: (eventName: AnalyticsEventNames | AnalyticsCoreEventNames, mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined, error?: Error, customData?: CustomDataMap, options?: DatapointOptions) => void): void {
    listeners.push(listener);
}
